/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const LinkedIn = ({ color = 'silver', height = 32, ...props }) => {
  return (
    <svg
      width={32}
      height={height}
      viewBox="0 0 32 32"
      sx={{ fill: color }}
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path d="M16 0C7.165 0 0 7.165 0 16s7.165 16 16 16 16-7.165 16-16S24.835 0 16 0zm-4.65 24.188H7.455V12.464h3.897v11.724zM9.403 10.863h-.025c-1.308 0-2.153-.9-2.153-2.025 0-1.15.871-2.025 2.204-2.025 1.333 0 2.153.875 2.179 2.025 0 1.125-.846 2.025-2.205 2.025zm16 13.325h-3.897v-6.272c0-1.576-.564-2.651-1.974-2.651-1.076 0-1.717.725-2 1.425-.102.25-.127.6-.127.95v6.548h-3.897s.051-10.624 0-11.724h3.897v1.66c.517-.799 1.444-1.935 3.511-1.935 2.564 0 4.486 1.676 4.486 5.276v6.723z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H32V32H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

LinkedIn.propTypes = {
  color: string,
  height: number,
}

export default LinkedIn
